import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerLocationInputResourceBundleEn(i18next: i18n): void {
  i18next.addResourceBundle(
    'en',
    'record-it-components',
    {
      input: {
        LocationInput: {
          noValue: 'no coordinates selected'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
